import axios from 'axios'
import GetAllEmails from './dto/GetAllEmails'
import { PagedResultDto } from '../../../../../services/dto/pagedResultDto'
import { PagedMailsResultRequestDto } from './dto/PagedMailsResultRequestDto'
import { FilteredUsersResultRequestDto } from './dto/FilteredUsersResultRequestDto'
import GetAllUsers from './dto/GetAllUsers'
const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_GET_ALL_EMAIL_HISTORIES = `${API_URL}/EmailProcess/GetPagedAll`
export const URL_GET_ALL_USERS_FILTERED = `${API_URL}/Email/GetAllUsersFiltered`

export function onGetAllPagedEmailHistory(pagedFilterAndSortedRequest: PagedMailsResultRequestDto): Promise<PagedResultDto<GetAllEmails>> {
    return axios.get(URL_GET_ALL_EMAIL_HISTORIES, { params: pagedFilterAndSortedRequest })
}
export function onGetAllUsersFiltered(filteredAndSortedRequest: FilteredUsersResultRequestDto): Promise<GetAllUsers> {
    return axios.get(URL_GET_ALL_USERS_FILTERED, { params: filteredAndSortedRequest })
}